// The agents run inside sandboxed srcdoc iframes, which inherit the page CSP: an inline <script>
// is refused there, a same-origin <script src> is allowed.
export const editorAgentUrl = new URL(
  "../components/composerv2/components/postComposer/attachment/editorAgent.js",
  import.meta.url
).toString();

export const previewAgentUrl = new URL(
  "../containers/content-factory/components/previewAgent.js",
  import.meta.url
).toString();
